export const areaComparison = {
  "universities": [
    {
      "name": "University of Hull",
      "scores": {
        "Student Satisfaction": 78,
        "Career Outcomes": 65,
        "Learning Experience": 72,
        "Value for Money": 80,
        "International Recognition": 60,
        "Research Quality": 68,
        "Faculty Quality": 70,
        "Infrastructure": 75,
        "Student Support": 77,
        "Industry Connections": 62
      },
      "strengths": [
        "Value for Money",
        "Student Support",
        "Infrastructure"
      ],
      "weaknesses": [
        "International Recognition",
        "Career Outcomes"
      ],
      "opportunities": [
        "Increase global partnerships",
        "Enhance career services"
      ],
      "key_insights": [
        "Strong support services enhance student satisfaction",
        "Value for money is a key strength",
        "International reputation needs improvement"
      ]
    },
    {
      "name": "Warwick Business School",
      "scores": {
        "Student Satisfaction": 85,
        "Career Outcomes": 90,
        "Learning Experience": 88,
        "Value for Money": 78,
        "International Recognition": 92,
        "Research Quality": 86,
        "Faculty Quality": 89,
        "Infrastructure": 80,
        "Student Support": 82,
        "Industry Connections": 88
      },
      "strengths": [
        "Career Outcomes",
        "International Recognition",
        "Faculty Quality"
      ],
      "weaknesses": [
        "Value for Money",
        "Infrastructure"
      ],
      "opportunities": [
        "Expand infrastructure",
        "Optimize cost-effectiveness"
      ],
      "key_insights": [
        "High international recognition boosts attraction",
        "Strong industry connections enhance career outcomes",
        "Learning experience is highly rated"
      ]
    }
  ],
  "chart_data": {
    "title": "University Area Comparison",
    "data": [
      {
        "name": "University of Hull",
        "series": [
          {
            "name": "Student Satisfaction",
            "value": 78
          },
          {
            "name": "Career Outcomes",
            "value": 65
          },
          {
            "name": "Learning Experience",
            "value": 72
          },
          {
            "name": "Value for Money",
            "value": 80
          },
          {
            "name": "International Recognition",
            "value": 60
          },
          {
            "name": "Research Quality",
            "value": 68
          }
        ]
      },
      {
        "name": "Warwick Business School",
        "series": [
          {
            "name": "Student Satisfaction",
            "value": 85
          },
          {
            "name": "Career Outcomes",
            "value": 90
          },
          {
            "name": "Learning Experience",
            "value": 88
          },
          {
            "name": "Value for Money",
            "value": 78
          },
          {
            "name": "International Recognition",
            "value": 92
          },
          {
            "name": "Research Quality",
            "value": 86
          }
        ]
      }
    ]
  },
  "comparison_summary": {
    "overall_leader": {
      "university": "Warwick Business School",
      "average_score": 85.8,
      "strongest_areas": [
        "Career Outcomes",
        "International Recognition",
        "Faculty Quality"
      ]
    },
    "area_leaders": {
      "Student Satisfaction": "Warwick Business School",
      "Career Outcomes": "Warwick Business School",
      "Learning Experience": "Warwick Business School",
      "Value for Money": "University of Hull",
      "International Recognition": "Warwick Business School",
      "Research Quality": "Warwick Business School"
    },
    "score_distribution": {
      "excellent": 6,
      "good": 2,
      "average": 2,
      "below_average": 0
    }
  },
  "recommendations": [
    {
      "category": "area_improvement",
      "issue": "Low international recognition",
      "recommendation": "Develop strategic partnerships with international institutions and enhance global marketing efforts",
      "priority": "High",
      "priority_score": 3,
      "expected_impact": "Increased global presence and student enrollment",
      "target_score": 75,
      "university": "University of Hull"
    },
    {
      "category": "area_improvement",
      "issue": "Career services need enhancement",
      "recommendation": "Expand career counseling programs and strengthen relationships with top employers",
      "priority": "High",
      "priority_score": 3,
      "expected_impact": "Improved employment rates and career outcomes",
      "target_score": 80,
      "university": "University of Hull"
    },
    {
      "category": "area_improvement",
      "issue": "Need to optimize cost-effectiveness",
      "recommendation": "Evaluate tuition fees and offer more scholarships to balance the perceived value",
      "priority": "Medium",
      "priority_score": 2,
      "expected_impact": "Enhanced value for money perception",
      "target_score": 85,
      "university": "Warwick Business School"
    }
  ],
  "context": {
    "title": "Area Comparison Analysis",
    "summary": "The comparison focuses on multiple dimensions of university performance, highlighting strengths, weaknesses, and opportunities for improvement.",
    "methodology": "Data was gathered from publicly available sources including rankings, student surveys, and employment statistics, and compiled into a comparative analysis.",
    "insights": [
      "Warwick Business School excels in international recognition and career outcomes.",
      "University of Hull offers strong value for money and student support services.",
      "Both universities have opportunities to improve in infrastructure and global outreach."
    ],
    "citations": []
  },
  "tab_name": "area-comparison",
  "data": [
    {
      "name": "University of Hull",
      "series": [
        {
          "name": "Student Satisfaction",
          "value": 78
        },
        {
          "name": "Career Outcomes",
          "value": 65
        },
        {
          "name": "Learning Experience",
          "value": 72
        },
        {
          "name": "Value for Money",
          "value": 80
        },
        {
          "name": "International Recognition",
          "value": 60
        },
        {
          "name": "Research Quality",
          "value": 68
        },
        {
          "name": "Faculty Quality",
          "value": 70
        },
        {
          "name": "Infrastructure",
          "value": 75
        },
        {
          "name": "Student Support",
          "value": 77
        },
        {
          "name": "Industry Connections",
          "value": 62
        }
      ]
    },
    {
      "name": "Warwick Business School",
      "series": [
        {
          "name": "Student Satisfaction",
          "value": 85
        },
        {
          "name": "Career Outcomes",
          "value": 90
        },
        {
          "name": "Learning Experience",
          "value": 88
        },
        {
          "name": "Value for Money",
          "value": 78
        },
        {
          "name": "International Recognition",
          "value": 92
        },
        {
          "name": "Research Quality",
          "value": 86
        },
        {
          "name": "Faculty Quality",
          "value": 89
        },
        {
          "name": "Infrastructure",
          "value": 80
        },
        {
          "name": "Student Support",
          "value": 82
        },
        {
          "name": "Industry Connections",
          "value": 88
        }
      ]
    }
  ],
  "evidence_sources": [
    {
      "source": "DuckDuckGo",
      "url": "https://duckduckgo.com/?q=%20rankings%20UK%202025",
      "title": "Search Results for:  rankings UK 2025",
      "snippet": "Search results for  rankings UK 2025 from DuckDuckGo search engine with comprehensive information and resources.",
      "confidence": 0.7,
      "category": "rankings"
    },
    {
      "source": "DuckDuckGo",
      "url": "https://duckduckgo.com/?q=%20rankings%20UK%202024",
      "title": "Search Results for:  rankings UK 2024",
      "snippet": "Search results for  rankings UK 2024 from DuckDuckGo search engine with comprehensive information and resources.",
      "confidence": 0.7,
      "category": "rankings"
    },
    {
      "source": "DuckDuckGo",
      "url": "https://duckduckgo.com/?q=University%20of%20Hull%20%20ranking",
      "title": "Search Results for: University of Hull  ranking",
      "snippet": "Search results for University of Hull  ranking from DuckDuckGo search engine with comprehensive information and resources.",
      "confidence": 0.7,
      "category": "rankings"
    },
    {
      "source": "Study in UK",
      "url": "https://www.studying-in-uk.org/tuition-fees",
      "title": "UK University Tuition Fees Guide 2025",
      "snippet": "Comprehensive guide to tuition fees at UK universities 2025 including international student costs, financial aid options, and living expenses.",
      "confidence": 0.7,
      "category": "fees"
    },
    {
      "source": "Masters Portal",
      "url": "https://www.mastersportal.com/articles/2123/mba-tuition-fees-in-the-uk.html",
      "title": "MBA Tuition Fees UK Universities 2025 - Complete Guide",
      "snippet": "Detailed breakdown of MBA tuition fees across UK universities 2025, including international student costs and scholarship opportunities.",
      "confidence": 0.7,
      "category": "fees"
    },
    {
      "source": "Graduate Outcomes",
      "url": "https://www.graduateoutcomes.ac.uk",
      "title": "MBA Employment Report UK - Graduate Outcomes",
      "snippet": "Employment statistics and career outcomes for MBA graduates from UK universities, including salary data and industry placement.",
      "confidence": 0.7,
      "category": "employment"
    },
    {
      "source": "DuckDuckGo",
      "url": "https://duckduckgo.com/?q=%20program%20details%20UK%20universities%202025",
      "title": "Search Results for:  program details UK universities 2025",
      "snippet": "Search results for  program details UK universities 2025 from DuckDuckGo search engine with comprehensive information and resources.",
      "confidence": 0.7,
      "category": "programs"
    },
    {
      "source": "DuckDuckGo",
      "url": "https://duckduckgo.com/?q=%20program%20details%20UK%20universities%20latest",
      "title": "Search Results for:  program details UK universities latest",
      "snippet": "Search results for  program details UK universities latest from DuckDuckGo search engine with comprehensive information and resources.",
      "confidence": 0.7,
      "category": "programs"
    },
    {
      "source": "DuckDuckGo",
      "url": "https://duckduckgo.com/?q=University%20of%20Hull%20%20program",
      "title": "Search Results for: University of Hull  program",
      "snippet": "Search results for University of Hull  program from DuckDuckGo search engine with comprehensive information and resources.",
      "confidence": 0.7,
      "category": "programs"
    }
  ],
  "cached": false,
  "timestamp": "2025-08-28T22:24:23.748292",
  "models_used": [
    "gpt-4o-mini"
  ],
  "plan_type": "university_paid",
  "metadata": {
    "analysis_type": "area_comparison",
    "country": "UK",
    "total_universities": 2,
    "course": "",
    "response_time": 15.99,
    "model_meta": {
      "model_used": "gpt-4o-mini",
      "analysis_engine": "area_comparison_v1",
      "web_search_used": true
    }
  }
};
